export default "__VITE_ASSET__3d2f9a46__"